import { EnumOption } from "./enum-option"

export const CompanyAssignType = {
    Position: 0,
    PW: 1,
    Recruitment: 2,
}

export const CompanyAssignTypeList: EnumOption[] = [
    { value: CompanyAssignType.Position, label: 'Position' },
    { value: CompanyAssignType.PW, label: 'PW' },
    { value: CompanyAssignType.Recruitment, label: 'Recruitment' },
]
